import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { search_icon } from "../../assets";
import { fetchStoreOrders } from "../../Redux/Action/orderAction";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import Table from "../Tables/TableOrder";
import LoadingSpinner from "../CustomWidgets/Laoding";
import { CustomerForm } from "./CustomerForm";
import { detectWebDeviceType, isTablet } from "../../utils";
import { Select } from "antd";
import CreditTableComponent from "./CreditTableComponent";
const { Option } = Select;


export function Modal({ isOpen, onClose, children, title }) {


  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto"; // cleanup
    };
  }, [isOpen]);
  
  if (!isOpen) return null;
  const deviceType = detectWebDeviceType();
  

  return (
    <div
      className={
        deviceType === "pc"
          ? "fixed inset-0 bg-black bg-opacity-50 backdrop-blur flex items-center justify-center p-4 z-50"
          : ""
      }
      style={
        deviceType === "tablet"
          ? {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
          }
          : {}
      }
    >
      <div
        className={`bg-white rounded-2xl ${deviceType === "tablet" ? "w-[55%] fixed left-16 " : "w-[80%]"
          }`}
      >
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-2xl font-semibold">{title}</h2>
          <button type="button" onClick={onClose} className="bg-transparent">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export function OrderSearchBar({
  fetchPosCreditData,
  searchTerm,
  setSearchTerm,
  setPagination,
}) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const ref = useRef(null);


  const handleSearchChange = (term) => {
    if (term.length >= 3 || term === "") {
      fetchPosCreditData(term, "", 1); // Reset to first page
    }
  };


  const debouncedSearch = useMemo(() => debounce(handleSearchChange, 300), []);

  const handleInputChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    setPagination((prev) => ({ ...prev, current: 1 }));
    debouncedSearch(term);
  };

  useEffect(() => {
    ref.current.focus();
  }, [searchTerm]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.shiftKey && event.key === "x") {
        ref.current.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [ref]);

  return (
    <div className={`relative flex ${isRtl ? "me-8" : "ms-8"} me-8 w-[100%]`}>
      {isRtl ? (
        <span className="absolute inset-y-0 right-0 flex items-center pr-3">
          <img src={search_icon} alt="customers_search_icon" />
        </span>
      ) : (
        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
          <img src={search_icon} alt="customers_search_icon" />
        </span>
      )}
      <input
        type="text"
        ref={ref}
        placeholder={t("Search Customer Name / Phone No.")}
        className="border p-3 ps-10 rounded w-full focus:outline-none rounded-[6px]"
        value={searchTerm} // Controlled input
        onChange={handleInputChange}
      />
    </div>
  );
}

function Credit_Table() {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();
  const [filteredData, setFilteredData] = useState([]);
  // const [pagination, setPagination] = useState(0);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const { user } = useSelector((state) => state?.login);
  const [selectedOrderIndex, setSelectedOrderIndex] = useState(-1);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingData, setIsLoadingData] = useState(false); // Define loading state

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [paymentType, setPaymentType] = useState(""); // default to "All" => empty string

  const lang = i18n.language;

  const isCreditAmountZero = selectedOrderDetails?.credit_amount === 0;

  useEffect(() => {
    fetchPosCreditData();
  }, []);


  const fetchPosCreditData = async (
    searchTerm = "",
    type = paymentType,
    page = 1,
    pageSize = pagination.pageSize
  ) => {
    const offset = (page - 1) * pageSize;
    const limit = pageSize;

    const payload = {
      search: searchTerm,
      ...(type && { type }),
      offset,
      limit,
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.GET_POS_CREDIT_LIST, payload);

      if (response?.data?.result[0]?.status_code === 200) {
        setFilteredData(response?.data?.result[0]?.response || []);
      }
    } catch (error) {
      console.error("Error fetching Pos Credit data:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleTablePageChange = (page) => {
    setPagination((prev) => ({ ...prev, current: page }));
    fetchPosCreditData(searchTerm, paymentType, page, pagination.pageSize);
  };

  const handleRowClick = async (order) => {
    setSelectedOrderDetails(order); // Set the selected order details here
    setIsModalOpen(true);
  };

  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: t("Customer Name"),
        accessor: "customer_name",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Phone No."),
        accessor: "mobile_no",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Address"),
        accessor: "address",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Balance Amount"),
        accessor: "credit_amount",
        Cell: ({ value }) => (
          <div className="flex-auto max-md:max-w-full">
            {"EGP"} {value}
          </div>
        ),
        sortType: "alphanumeric",
      },
      {
        // Header: t("Status"),
        accessor: "status",
        // width: "10%",
        Cell: ({ row }) => {
          const creditAmount = row.original?.credit_amount;

          const isUnpaid = creditAmount > 0;
          const statusLabel = isUnpaid ? t("Unpaid") : t("Paid");

          const bgColor = isUnpaid ? "bg-[#F42020] text-white" : "bg-[#7EC242] text-white";
          const widthClass = isUnpaid ? "w-24" : "w-24";

          return (
            <div className="text-center">
              <span
                className={`flex justify-center font-semibold text-lg rounded-xl ${bgColor} ${widthClass}`}
                style={{
                  padding: "0.4rem 0.8rem",
                }}
              >
                {statusLabel}
              </span>
            </div>
          );
        },
      },
    ];

    return baseColumns;
  }, [user?.currency]);

  const handleSubmit = () => {
    fetchPosCreditData();
    setIsModalOpen(false);
  };

  let EKey = localStorage.getItem("eKeyPressed");

  const handleKeyDown = useCallback(
    (e) => {
      if (EKey === "true") {
        return;
      }
      if (e.shiftKey && e.key === "e") {
        setSelectedOrderIndex(null);
        return;
      }

      const normalizedKey = e.key.toLowerCase();

      if (normalizedKey === "arrowup" && !isModalOpen) {
        e.preventDefault();
        if (selectedOrderIndex > 0) {
          setSelectedOrderIndex(selectedOrderIndex - 1);
        }
      } else if (normalizedKey === "arrowdown" && !isModalOpen) {
        e.preventDefault();
        if (selectedOrderIndex < filteredData.length - 1) {
          setSelectedOrderIndex(selectedOrderIndex + 1);
        }
      } else if (
        normalizedKey === "enter" &&
        selectedOrderIndex >= 0 &&
        !isModalOpen
      ) {
        e.preventDefault();
        const selectedOrder = filteredData[selectedOrderIndex];
        handleRowClick(selectedOrder); // Open modal for selected row
      } else if (normalizedKey === "escape") {
        e.preventDefault();
        setIsModalOpen(false);
      } else if (e.shiftKey && normalizedKey === "e") {
        e.preventDefault();
        setIsModalOpen(false);
      }
    },
    [selectedOrderIndex, filteredData, isModalOpen, EKey]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  const [eKeyPressed, setEKeyPressed] = useState(
    localStorage.getItem("eKeyPressed")
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setEKeyPressed(localStorage.getItem("eKeyPressed"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (eKeyPressed !== "true") {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown, eKeyPressed]);


  const handleFilterChange = (newValue) => {
    setPaymentType(newValue);
    setPagination((prev) => ({ ...prev, current: 1 })); // Reset to first page
    fetchPosCreditData(searchTerm, newValue, 1, pagination.pageSize);
  };

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        isCreditAmountZero={isCreditAmountZero}
        title={t("Customer Credit Details")}
      >
        <CustomerForm
          onSubmit={handleSubmit}
          orderDetails={selectedOrderDetails}
        />
      </Modal>
      {loading ? (
        <div className="px-5">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="flex">
          <div className="flex-grow transition-all duration-300 w-full">
            <div className="bg-[#EEEEEE] mt-2">
              <div className="flex flex-row gap-4 bg-[#EEEEEE]">
                {filteredData && filteredData.length > 0 && (
                  <div className={`${isRtl ? "ms-20" : "ms-12"} bg-[#EEEEEE] flex items-center gap-4`}>
                    <div className="flex-grow min-w-[250px] mt-3">
                      <OrderSearchBar
                        fetchPosCreditData={fetchPosCreditData}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        setPagination={setPagination}
                      // ref={searchInputRef}
                      />
                    </div>

                    <div className={`${isRtl ? "" : "ms-8"} w-40 min-w-[150px]`}>
                      <Select
                        value={paymentType}
                        onChange={handleFilterChange}
                        className="custom-select-height rounded-[6px] text-xl font-bold"
                        popupClassName="payment-type-dropdown"
                        style={{ width: "100%" }}
                        options={[
                          { value: "", label: t("All") },
                          { value: "paid", label: t("Paid") },
                          { value: "unpaid", label: t("Unpaid") },
                        ]}
                      />
                    </div>
                  </div>

                )}
              </div>
            </div>
            {filteredData && filteredData.length === 0 && (
              <div className="flex flex-col justify-center mr-20 ml-20 mt-8 text-sm bg-white text-left rounded-[15px] overflow-hidden">
                <p className="text-center py-4 text-lg font-semibold text-zinc-800">
                  {t("Data not found")}
                </p>
              </div>
            )}

            {filteredData && filteredData.length > 0 && (
              <div className="flex flex-col justify-center mx-20 mt-7 mb-4 pb-2 text-sm bg-white text-left rounded-[15px] overflow-hidden">
                {/* {console.log("filteredData", filteredData)} */}
                <CreditTableComponent
                  columns={columns}
                  data={filteredData}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    onChange: handleTablePageChange,
                  }}
                  isLoadingData={loading}
                  onRowClick={handleRowClick}
                  selectedRowIndex={selectedOrderIndex}
                />
                {/* <Table
                  columns={columns}
                  data={filteredData}
                  pagination={pagination}
                  isLoadingData={isLoadingData}
                  setPagination={setPagination}
                  onRowClick={(val) => {
                    handleRowClick(val);
                  }}
                  selectedRowIndex={selectedOrderIndex}
                /> */}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Credit_Table;
